var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.423 6.64679C16.4369 6.67413 16.4524 6.70052 16.4694 6.72584C16.5578 6.9982 16.6144 7.28545 16.6345 7.58335L17.457 19.7353C17.5138 20.5753 17.2741 21.3631 16.83 22H18.9754C20.1503 22 21.0785 21.0028 20.9948 19.8304L20.1271 7.67849C20.0514 6.61863 19.1698 5.79747 18.1077 5.79747H17.8598C17.8598 3.70018 16.1604 2 14.0639 2C14.0438 2 14.0239 2.00078 14.0042 2.00232C14.4703 2.49614 14.8327 3.08905 15.0563 3.74609C15.817 4.11506 16.3414 4.89499 16.3414 5.79747H16.0077C16.1402 5.98757 16.2546 6.19146 16.3484 6.40673C16.3525 6.43733 16.3584 6.46734 16.3661 6.49667C16.3861 6.54614 16.4051 6.59619 16.423 6.64679Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91785 5.79747H7.23125V5.29114C7.23125 3.47349 8.70415 2 10.5211 2C12.338 2 13.8109 3.47349 13.8109 5.29114V5.92607C14.5343 6.19769 15.0646 6.87224 15.1196 7.68597L15.9421 19.8379C16.0212 21.0076 15.0941 22 13.9222 22H4.01229C3.42633 22 2.96278 21.5038 3.00236 20.9189L3.89798 7.68597C3.96992 6.62295 4.85283 5.79747 5.91785 5.79747ZM8.74962 5.79747H12.2925V5.29114C12.2925 4.31241 11.4994 3.51899 10.5211 3.51899C9.54272 3.51899 8.74962 4.31241 8.74962 5.29114V5.79747Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.5cb2b7417dca4fbefe21cbf6a32e75e5.svg";
export { ForwardRef as ReactComponent };